import React from "react";
import { useState } from "react";
import { BrowserRouter as Router } from "react-router-dom";

import "../Assets/css/App.css";
import Home from "./Home";

const App = () => {
  return <Home />;
};

export default App;
